import React from 'react';
import { Button } from 'antd';
import { SignatureOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';

export default function SignatureButton({ onClick, hasSignature }) {
  const { t } = useTranslation();

  return (
    <Button
      type={hasSignature ? 'dashed' : 'primary'}
      size={hasSignature ? 'default' : 'large'}
      icon={<SignatureOutlined />}
      onClick={onClick}
    >
      {hasSignature 
        ? t('patient_documents.signature.edit')
        : t('patient_documents.signature.add')
      }
    </Button>
  );
} 